import React, { useState, useEffect } from "react";
import axios from "axios";
import FoodCard from "../../generals/food_card";

function AdminFoods({ handleToast, id }) {
  const [foods, setFoods] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    // localStorage.removeItem("foods");
    // Check if products are already in localStorage
    const storedFoods = localStorage.getItem("foods");
    if (storedFoods) {
      // Use cached data if available
      setFoods(JSON.parse(storedFoods));
    } else {
      // Fetch products from the API
      axios
        .get(`https://api.dectwinhotel.com/api/${id}_foods/foods`)
        .then((response) => {
          setFoods(response.data);
          // Store products in localStorage
          localStorage.setItem("foods", JSON.stringify(response.data));
        })
        .catch((error) => {
          console.error("Error fetching products:", error);
        });
    }
  }, [id]);

      const filteredItems = foods.filter(item =>
        item.food_name.toLowerCase().includes(searchQuery.toLowerCase())
      );

  return (
    <section>

                    <div className="text-center px-5 mt-1">
                        <input
                            type="text"
                            className="rounded border-0 bg-white"
                            style={{outline: '0'}}
                            placeholder="🔍 Search food Item..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>


      <div className="rooms-data">
        {filteredItems.length > 0 ? (
          filteredItems.map((food) => (
            <FoodCard
              key={food.food_id}
              foodData={food}
              bookingId={null}
              updateTotals={function () {}}
              handleToast={handleToast}
              id={id}
            />
          ))
        ) : (
          <div className="no-rooms-message">
            <i
              style={{ fontSize: "6rem", margin: "30px 10px" }}
              className="fa fa-cutlery"
            ></i>
            <p>No Food Items Added Yet.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default AdminFoods;
